import { useOutletContext } from 'react-router-dom'

import { ExportTrainingsDataDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ParticipantsOneDataTable from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable'
import { TrainingEmployeesDataTable } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable'
import { DetailOutletContext } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

const Participants = () => {
  const context = useOutletContext<DetailOutletContext>()
  const { classes, training, hasParticipantOneDataCollection, completionConfiguration } =
    context ?? {}

  const { data, loading, error } = useQuery(ExportTrainingsDataDocument, {
    skip: hasParticipantOneDataCollection,
  })

  if (!context) {
    return (
      <ResponsivePage.Body showHeader={false} loading error={null}>
        {null}
      </ResponsivePage.Body>
    )
  }

  const participantTable = hasParticipantOneDataCollection ? (
    <ParticipantsOneDataTable
      training={training}
      trainingClasses={classes}
      completionConfiguration={completionConfiguration}
      outletContext={context}
    />
  ) : (
    <TrainingEmployeesDataTable
      training={training}
      trainingClasses={classes}
      teams={data?.teams.teams ?? []}
      outletContext={context}
    />
  )

  return (
    <ResponsivePage.Body showHeader={false} loading={loading} error={error}>
      {participantTable}
    </ResponsivePage.Body>
  )
}

export default Participants
